module.exports = __webpack_public_path__ + "static/media/moto_3.c32cd3f8.png";